import classNames from 'classnames';
import React from 'react';
import { DisgustFace, HappyFace, NeutralFace, SadFace, SurpriseFace } from '../../ui/icons/icons';
import { ChartOrderItem } from '../../utils/types/analytics/analytics_types';
import styles from './analytics.module.css';
import { DashletIconGroup } from './DashletIconGroup';

type EmotionDashletProps = {
    id: string,
    name: string,
    value: string,
    dashletItem:ChartOrderItem,
    onDragStart: (item: ChartOrderItem) => void,
    onDragEnter: (item: ChartOrderItem) => void,
    onDragOver: (event: React.DragEvent<HTMLDivElement>) => void,
    onDrop: (event: React.DragEvent<HTMLDivElement>) => void,
    fullScreenDetected: boolean,
    setFullScreenDetected: (fullscreen: boolean) => void,
    handleDashletVisibility: (item: ChartOrderItem) => void,
    editMode: boolean,
}

export const EmotionDashlet = ({ id, name, value, dashletItem, onDragStart, onDragEnter, onDragOver, onDrop, fullScreenDetected, setFullScreenDetected, handleDashletVisibility, editMode }: EmotionDashletProps) => {
  const handleDragStart = () => {
    if (onDragStart) {
      onDragStart(dashletItem);
    }
  };

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (onDragEnter) {
      onDragEnter(dashletItem);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (onDragOver) {
      onDragOver(event);
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (onDrop) {
      onDrop(event);
    }
  };

  const handleEmoji = () => {
    switch (value) {
      case 'Neutral':
      case '':
        return <NeutralFace/>;
      case 'Happy':
        return <HappyFace/>;
      case 'Sad':
        return <SadFace/>;
      case 'Disgust':
        return <DisgustFace/>;
      case 'Surprise':
        return <SurpriseFace/>;
      default:
        return <NeutralFace/>;
    }
  };

  return (
    <div className='flex justify-center items-center group relative w-full col-span-1 pt-2 h-full border border-gray-200 shadow rounded overflow-hidden hover:cursor-pointer'>
      <DashletIconGroup id={id} dashletItem={dashletItem} setFullScreenDetected={setFullScreenDetected} handleDashletVisibility={handleDashletVisibility} editMode={editMode}/>
      <div id={id}
          draggable
          onDragStart={handleDragStart}
          onDragEnter={handleDragEnter}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          className={`flex flex-col justify-center bg-white w-full h-full ${dashletItem.hidden ? 'opacity-40' : ''}`}
      >
        <div className={classNames('font-bold text-center', fullScreenDetected? 'text-4xl mb-6' : 'text-sm mb-2')}> { name }</div>
        <div className={classNames(styles.numeriacalContainer, 'font-bold text-green-500 flex place-content-center place-items-center', fullScreenDetected ? 'text-9xl' : 'text-3xl')}>
          <div className='flex flex-col'>
            { handleEmoji() }
            <div className={classNames('font-bold text-center text-black', fullScreenDetected? 'text-4xl mb-6' : 'text-sm mb-2')}> { value }</div>
          </div>
        </div>
      </div>
    </div>
  );
};
